import type { CSSObject } from '@emotion/react';

export const contactsListStyles: CSSObject = {
  width: '100%',
  listStyle: 'none',
  margin: 0,
  paddingInlineStart: 0,
  maxHeight: '40vh',
  overflowY: 'auto',
};

export const drawerHeaderStyles: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding:
    'var(--fabric-number-n-2-px) var(--fabric-number-n-8-px) var(--fabric-number-n-2-px) var(--fabric-number-n-4-px)',
  borderBottom: '1px solid var(--fabric-color-neutral-10)',
};

export const drawerHeaderCompactStyles: CSSObject = {
  padding:
    'var(--fabric-number-n-1-px) var(--fabric-number-n-4-px) var(--fabric-number-n-1-px) var(--fabric-number-n-2-px)',
};

export const drawerHeaderCenterStyles: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};
